import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import Button from "../../../common/Buttons";
import Modal from "../../../common/Modal";
import { media } from "utils/style";

const FormerPendingRequest = ({
  modalContent: { section_title, section_description, buttons },
  closeModal,
  dateOfRequest,
  ...props
}) => {
  return (
    <Modal id={"modalStyle"} visibleModal closeModal={closeModal} contentLabel="pending modal" {...props}>
       <Container>
      <H2>{section_title}</H2>
      <Div>
        {section_description}
     
        <div style={{ marginTop: "32px" }}>
      <Button background={buttons[0].type} onClick={closeModal}>
        {buttons[0].text}
      </Button>
      </div>
      </Div>
      </Container>
    </Modal>
  );
};

export { FormerPendingRequest };

FormerPendingRequest.propTypes = {
  closeModal: PropTypes.func.isRequired
};


const Container = styled.div`
  max-width: 420px;

  ${media.mobile`
    padding-right: 0;
  `}
`;

const Div = styled.div`
  margin-top: 32px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;

  p {
    padding: 10px 0;
  }

  ${media.mobile`
  @media only screen and (max-width: 480px) {
    div {
      position:absolute;
      bottom:10px;
      right:0px;
      left:0px;
      margin:20px
    }
  }
 
`}
`;

const H2 = styled.h2`
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 32px;
  ${media.mobile`
  font-weight: 400;
  font-size: 24px;
`}
`;
